import { FileSpreadsheet, Smartphone } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

const MODULES = [
  { n: "01", t: "Arquitectura y despiece crítico del Mindray BA-88A", d: "Anatomía completa del equipo, fuentes conmutadas, tarjetas de control y desmontaje seguro del bloque óptico sin desalinear componentes." },
  { n: "02", t: "Hidráulica y fluídica de precisión", d: "Presiones de vacío, mantenimiento y ajuste de bomba peristáltica, mangueras, detección de microfugas y desobstrucción química de celdas de flujo." },
  { n: "03", t: "Electrónica fotométrica y medición de señales", d: "Aislamiento de fallas en lámpara halógena, fotodiodos, preamplificadores y comprobación de voltajes de referencia en milivoltios." },
  { n: "04", t: "Parametrización y software operativo", d: "Configuración técnica de técnicas analíticas (glucosa, colesterol, enzimas), factores de absorbancia y ajustes del sistema sin claves de fábrica." },
  { n: "05", t: "Calibración fina y pruebas de desempeño", d: "Verificación de linealidad, repetibilidad, ajuste de blanco de reactivo/agua y entrega operativa bajo estándares de control de calidad." },
];

const RESOURCES = [
  { icon: FileSpreadsheet, t: "Hojas de cálculo automatizadas", d: "Plantillas personales para verificar factores de calibración y validar la linealidad analítica al instante." },
  { icon: Smartphone, t: "Esquemas de diagnóstico rápido", d: "Mapas de flujo optimizados para llevar en tu celular e identificar fallas directamente en la mesa del cliente." },
];

export const Modulos = () => (
  <Section id="incluye" band>
    <Reveal>
      <Kicker num="04" label="Qué incluye el programa" />
      <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        Acceso completo y de por vida a los 5 módulos técnicos de especialización
      </h2>
      <p className="mt-5 max-w-3xl text-base leading-relaxed text-slate-400 md:text-lg">
        Esta primera generación se impartirá con sesiones en vivo junto al mentor y
        quedará grabada en HD sobre analizadores reales en taller, mostrando mediciones
        punto por punto.
      </p>
    </Reveal>

    <div className="mt-12 space-y-4">
      {MODULES.map((m, i) => (
        <Reveal key={m.n} delay={i * 0.06}>
          <div
            data-testid={`module-row-${m.n}`}
            className="group flex items-start gap-6 rounded-2xl border border-white/5 bg-white/[0.02] p-6 transition-all duration-300 hover:border-cyan-400/35 hover:bg-cyan-400/[0.03]"
          >
            <span className="font-tech text-2xl font-semibold text-cyan-400/70 transition-colors duration-300 group-hover:text-cyan-300 sm:text-3xl">
              {m.n}
            </span>
            <div>
              <h3 className="font-display text-base font-semibold text-slate-50 sm:text-xl">{m.t}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{m.d}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    <div className="mt-10 grid gap-5 sm:grid-cols-2">
      {RESOURCES.map((r, i) => (
        <Reveal key={r.t} delay={i * 0.08} className="h-full">
          <div className="h-full rounded-2xl bg-gradient-to-br from-cyan-400/40 via-white/5 to-amber-400/30 p-px">
            <div className="flex h-full flex-col rounded-2xl bg-[#0B1322] p-6">
              <r.icon className="mb-4 h-6 w-6 text-cyan-300" />
              <span className="font-tech text-[10px] tracking-[0.3em] text-cyan-400">RECURSO DESCARGABLE</span>
              <h3 className="mt-2 font-display text-lg font-semibold text-slate-50 sm:text-xl">{r.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{r.d}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
